// laser-wave.js - create in assets and include via script_tag
(function(){
  // avoid running twice
  if (window._laserWaveInitialized) return;
  window._laserWaveInitialized = true;

  // create container and append to body
  const container = document.createElement('div');
  container.className = 'laser-wave';
  container.id = 'laserWave';
  document.body.appendChild(container);

  const beamCount = 8;
  const beams = [];

  for (let i = 0; i < beamCount; i++) {
    const b = document.createElement('div');
    b.className = 'laser-beam';
    // assign a base angle as CSS variable so animation keyframes can read it
    const baseAngle = (Math.random() * 30 - 15).toFixed(2) + 'deg';
    b.style.setProperty('--angle', baseAngle);
    b.style.top = `${(i / beamCount) * 100}%`;
    b.style.animationDelay = `${Math.random() * -18}s`;
    b.style.opacity = (0.2 + Math.random() * 0.5).toString();
    container.appendChild(b);
    beams.push({el: b, base: parseFloat(baseAngle) || 0});
  }

  // small throttle for mousemove/scroll updates
  let lastT = 0;
  let mouseX = 0;
  let scrollY = 0;

  function updateBeamAngles() {
    beams.forEach((bobj, idx) => {
      const dynamic = bobj.base + mouseX * 0.25 + scrollY * 0.15;
      bobj.el.style.transform = `translateX(-50%) rotate(${dynamic}deg)`;
    });
  }

  document.addEventListener('mousemove', function(e){
    // only update ~60fps
    const now = performance.now();
    if (now - lastT < 16) return;
    lastT = now;
    mouseX = (e.clientX / window.innerWidth - 0.5) * 40; // wider tilt range
    updateBeamAngles();
  }, {passive:true});

  document.addEventListener('scroll', function(){
    const now = performance.now();
    if (now - lastT < 50) return;
    lastT = now;
    scrollY = (window.scrollY / Math.max(document.body.scrollHeight - window.innerHeight, 1)) * 30;
    updateBeamAngles();
  }, {passive:true});

  // ensure beams respond after theme sections load (Dawn loads some content dynamically)
  window.addEventListener('load', function(){
    // small fade-in
    container.style.transition = 'opacity 800ms ease';
    container.style.opacity = '1';
  });

})();
